import { defaultTestingSet } from './defaultTestingSet';

export const testingSets = [
  defaultTestingSet
]


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/testing-portal/pressure-test/config/testingSets/index.js